import { Button, Form, Input } from 'antd'
import { memo, useCallback } from 'react'
import { User } from 'types/users'

type Props = {
    data: User
    onSubmit: (data: User) => void
    loading: boolean
}

export const UserForm = memo((props: Props) => {
    const { data, onSubmit, loading } = props

    const onFinish = useCallback(
        (values: User) => {
            onSubmit(values)
        },
        [onSubmit]
    )

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={data.email}
                label='E-mail'
                name='email'
                rules={[{ required: true, message: 'Please input user E-mail!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item initialValue={data.name} label='Name' name='name'>
                <Input />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
